import { Button as RoccoButton } from '@archipro/rocco/components/button';
import { CheckboxBlankLine, CheckboxFill } from '@archipro-design/icons';
import type {
    FilterBarCheckboxFilter,
    FilterState,
    FilterStatesKey,
} from '../../type/filter-state';
import type { ReactElement } from 'react';
import { FilterDropdown } from '@rocco/ui/filter-sort/components/filters-bar/FilterDropdown';
import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { Label as RoccoLabel } from '@rocco/components/label';
import type { FilterStates } from '../../type/filter-state';
interface FilterBarFiltersProps {
    filters: FilterBarCheckboxFilter[];
    updateFilter: (
        filterKey: FilterStatesKey,
        state: Partial<FilterState>
    ) => void;
    componentBarAddon?: ReactElement;
    filterStates?: FilterStates; // currently only used for the downloads filter in products
}

const FilterBarFilters = ({
    filters,
    updateFilter,
    componentBarAddon,
    filterStates,
}: FilterBarFiltersProps) => {
    return (
        <div className="flex gap-2 items-center flex-row">
            {componentBarAddon}
            {filters.map(
                ({ filterKey, label, checked, disabled, newState }) => {
                    if (filterKey === 'downloads') {
                        const selectedItems =
                            filterStates?.downloads?.selectedItems || [];
                        const downloadsState =
                            filterStates?.downloads?.items || [];
                        if (downloadsState.length === 0) {
                            return null;
                        }
                        const allChecked =
                            selectedItems.length === downloadsState.length;
                        const allCheckedState = downloadsState.map((item) => ({
                            ...item,
                            checked: allChecked,
                        }));
                        const renderItems = [
                            {
                                value: 'all',
                                label: 'Select All',
                                checked: allChecked,
                            },
                            ...downloadsState,
                        ];

                        return (
                            <FilterDropdown
                                title={label}
                                selected={checked}
                                closeOnScroll
                                key={filterKey}
                            >
                                <div className="flex flex-col gap-2">
                                    {renderItems.map((state, index) => (
                                        <div
                                            key={state.value}
                                            className="flex items-center w-full"
                                        >
                                            <RoccoCheckbox
                                                checked={
                                                    state.value === 'all'
                                                        ? allChecked
                                                        : !!selectedItems.find(
                                                              (item) =>
                                                                  item.value ===
                                                                  state.value
                                                          )
                                                }
                                                id={state.value}
                                                groupHover="light"
                                                // reuse the same logic as the searchable list
                                                onCheckedChange={(data) => {
                                                    if (state.value === 'all') {
                                                        const updatedState = {
                                                            ...newState,
                                                            selectedItems:
                                                                allChecked
                                                                    ? []
                                                                    : allCheckedState,
                                                        };
                                                        return updateFilter(
                                                            filterKey,
                                                            updatedState
                                                        );
                                                    }
                                                    const checked = !!data;
                                                    const newList = [
                                                        ...downloadsState,
                                                    ];
                                                    const item = newList[index];
                                                    if (item) {
                                                        item.checked = checked;
                                                    }

                                                    const newSelectedItems =
                                                        selectedItems
                                                            ? [...selectedItems]
                                                            : [];
                                                    const selectedIndex =
                                                        newSelectedItems.findIndex(
                                                            (item) =>
                                                                item.value ===
                                                                state.value
                                                        );
                                                    if (selectedIndex !== -1) {
                                                        if (!checked) {
                                                            newSelectedItems.splice(
                                                                selectedIndex,
                                                                1
                                                            );
                                                        }
                                                    } else {
                                                        if (checked) {
                                                            newSelectedItems.push(
                                                                state
                                                            );
                                                        }
                                                    }
                                                    updateFilter(filterKey, {
                                                        kind: 'SearchList',
                                                        items: newList,
                                                        selectedItems:
                                                            newSelectedItems,
                                                    });
                                                }}
                                            />
                                            <RoccoLabel
                                                htmlFor={state.value}
                                                target="checkbox"
                                            >
                                                {state.label === 'All' &&
                                                allChecked
                                                    ? 'Clear All'
                                                    : state.label}
                                            </RoccoLabel>
                                        </div>
                                    ))}
                                </div>
                            </FilterDropdown>
                        );
                    }
                    return (
                        <RoccoButton
                            key={filterKey}
                            color={checked ? 'primary' : 'secondary'}
                            disabled={disabled}
                            onClick={() => {
                                updateFilter(filterKey, newState);
                            }}
                            clickAnimation="scale"
                        >
                            {checked ? <CheckboxFill /> : <CheckboxBlankLine />}
                            <span className="ml-2 text-sm leading-[1.625rem] tracking-0 md:text-base md:tracking-0">
                                {label}
                            </span>
                        </RoccoButton>
                    );
                }
            )}
        </div>
    );
};

export default FilterBarFilters;
